import script from "./PgmLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmLogin.vue?vue&type=script&setup=true&lang=ts"

import "./PgmLogin.vue?vue&type=style&index=0&id=36298513&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36298513"]])

export default __exports__